import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public MovuRobotics: MovuRobotics_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
